/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import e from "prop-types";
const i = (o) => o.replace(/^k-i-/, ""), n = (o) => "k-i-" + o, r = e.shape({
  name: e.string.isRequired,
  content: e.string.isRequired,
  viewBox: e.string.isRequired
});
export {
  r as svgIconPropType,
  n as toIconClass,
  i as toIconName
};
